import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/matches';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 no-underline mb-4">
              <div className="w-9 h-9 bg-primary-500 rounded-lg flex items-center justify-center">
                <i className="ri-football-line text-background-50 text-lg"></i>
              </div>
              <span className="text-xl font-bold text-background-50 whitespace-nowrap" style={{ fontFamily: 'var(--font-heading)' }}>
                {siteInfo.name}
              </span>
            </Link>
            <p className="text-foreground-400 text-sm leading-relaxed">
              沉浸式真实赛事竞猜平台，汇聚全球顶级赛事，提供安全、透明的竞猜体验。
            </p>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold mb-4 text-sm">热门分类</h4>
            <div className="space-y-2">
              <Link to="/category/football" className="block text-foreground-400 text-sm hover:text-background-50 transition-colors no-underline">足球竞猜</Link>
              <Link to="/category/basketball" className="block text-foreground-400 text-sm hover:text-background-50 transition-colors no-underline">篮球押注</Link>
              <Link to="/category/tennis" className="block text-foreground-400 text-sm hover:text-background-50 transition-colors no-underline">网球竞猜</Link>
            </div>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold mb-4 text-sm">关于我们</h4>
            <div className="space-y-2">
              <Link to="/about" className="block text-foreground-400 text-sm hover:text-background-50 transition-colors no-underline">品牌介绍</Link>
              <Link to="/about" className="block text-foreground-400 text-sm hover:text-background-50 transition-colors no-underline">平台信誉</Link>
              <Link to="/about" className="block text-foreground-400 text-sm hover:text-background-50 transition-colors no-underline">联系我们</Link>
            </div>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold mb-4 text-sm">联系方式</h4>
            <div className="space-y-2 text-sm text-foreground-400">
              <p><i className="ri-phone-line mr-2"></i>{siteInfo.phone}</p>
              <p><i className="ri-mail-line mr-2"></i>{siteInfo.email}</p>
              <p><i className="ri-map-pin-line mr-2"></i>{siteInfo.address}</p>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-500 text-xs">
            &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有 | 致力于提供安全可靠的赛事竞猜体验
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-500 text-xs hover:text-background-50 transition-colors no-underline">隐私政策</a>
            <a href="#" className="text-foreground-500 text-xs hover:text-background-50 transition-colors no-underline">用户协议</a>
            <a href="#" className="text-foreground-500 text-xs hover:text-background-50 transition-colors no-underline">责任博彩</a>
          </div>
        </div>
      </div>
    </footer>
  );
}